import { inject, Injectable, signal, Signal } from '@angular/core';

import { produce } from 'immer';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppState, emptyState } from './models/app-state.model';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class StateManagerService {
  private readonly _storageService: StorageService = inject(StorageService);
  private readonly _stateSubject: BehaviorSubject<AppState> = new BehaviorSubject<AppState>(emptyState);

  private readonly _state = signal<AppState>(emptyState);
  public readonly _currentState = this._state.asReadonly();
  public readonly state$: Observable<AppState> = this._stateSubject.asObservable();

  public initialize(): void {
    const storageState = this._storageService.read();
    if (
      storageState &&
      !!storageState.language &&
      !!storageState.countries &&
      !!storageState.stations &&
      !!storageState.imageLayout
    ) {
      this._stateSubject.next(storageState);
      this._state.set(storageState);
    }
  }

  public getState(): Signal<AppState> {
    return this._state.asReadonly();
  }

  public get currentState(): AppState {
    return this._stateSubject.value;
  }

  public update(f: (draft: AppState) => void): void {
    const nextState: AppState = produce(this._stateSubject.value, (draft: AppState) => {
      f(draft);
    });

    this._stateSubject.next(nextState);
    this._state.set(nextState);
    this._storageService.store(nextState);
  }
}
